  
    import React from 'react';

    const LoadingOrder = () => (
      <div className="text-left" style={{marginLeft:"15px"}}>
        <i className="fa fa-spinner fa-spin" /> Your content is being prepared. Please wait...
      </div>
    );

    export default LoadingOrder;
  
